// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__jiePY","contentControl":"styles_contentControl__2ijFO","modal":"styles_modal__3Bhue","loaderWrap":"styles_loaderWrap__119Je"};